import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@eventify/shared/i18n/locales/en.json";
import he from "@eventify/shared/i18n/locales/he.json";

// Default to Hebrew — the brand serves the Israeli market. English speakers can
// switch via the language toggle and the choice is persisted in localStorage.
function getInitialLanguage(): string {
  if (typeof window === "undefined") return "he";
  const saved = localStorage.getItem("eventify-language");
  if (saved) return saved;
  const browserLang = navigator.language.split("-")[0];
  // Browser detection only flips us to English if the browser is explicitly English.
  return browserLang === "en" ? "en" : "he";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    he: { translation: he },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
    // Custom formatter so {{amount, number}} formats numbers per the active locale.
    format: (value, format, lng) => {
      if (format === "number") {
        const n = typeof value === "number" ? value : Number(value);
        if (Number.isFinite(n)) {
          return new Intl.NumberFormat(lng === "he" ? "he-IL" : "en-US").format(n);
        }
      }
      return value;
    },
  },
});

export default i18n;
